<template>
  <div>
    <heading>{{ $t("sidebar.settings") }}</heading>
    <v-tabs :value="$route.path">
      <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" exact>
        {{ tab.name }}
      </v-tab>

      <v-tab-item
        v-for="tab of tabs"
        :key="tab.id"
        :value="tab.route"
        :transition="false"
        :reverse-transition="false"
      >
        <router-view></router-view>
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import { canView, hasPermission } from "../../utils/access";

export default {
  watch: {
    "$route.path": {
      immediate: true,
      handler(path) {
        const known = this.allTabs.some((tab) => tab.route === path);
        const allowed = this.tabs.some((tab) => tab.route === path);
        if (known && !allowed) {
          this.$router.replace({ path: "/app/settings/profile" });
        }
      },
    },
  },
  computed: {
    tabs() {
      return this.allTabs.filter(
        (tab) =>
          (!tab.module || canView(tab.module)) &&
          (!tab.alsoModule || canView(tab.alsoModule)) &&
          (!tab.permission || hasPermission(tab.permission))
      );
    },
    allTabs() {
      return [
        {
          id: 1,
          name: this.$t("settings.profileTab"),
          route: "/app/settings/profile",
        },
        {
          id: 2,
          name: this.$t("settings.user"),
          route: "/app/settings/users",
          module: "users",
        },
        {
          id: 3,
          name: this.$t("settings.boards"),
          route: "/app/settings/boards",
          module: "settings",
          alsoModule: "tickets",
        },
        {
          id: 4,
          name: this.$t("settings.emailTab"),
          route: "/app/settings/email",
          module: "settings",
        },
        {
          id: 5,
          name: this.$t("settings.proofersTab"),
          route: "/app/settings/proofers",
          module: "settings",
        },
        {
          id: 10,
          name: this.$t("settings.incidentReportTab"),
          route: "/app/settings/incidentReport",
          module: "settings",
          alsoModule: "incidentReport",
        },
        {
          id: 6,
          name: this.$t("settings.multiuserTab"),
          route: "/app/settings/multiuser",
          permission: "multiusermanagement",
          module: "settings",
        },
        {
          id: 7,
          name: this.$t("settings.tariffTab"),
          route: "/app/settings/tariff",
          module: "settings",
        },
        {
          id: 8,
          name: this.$t("settings.integrations"),
          route: "/app/settings/integrations",
          module: "settings",
        },
        // temporarily hidden
        // {
        //   id: 9,
        //   name: this.$t("settings.statisticsTab"),
        //   route: "/app/settings/statistics",
        // },
      ];
    },
  },
};
</script>
